import { render, staticRenderFns } from "./GiftCardManagerCreate.vue?vue&type=template&id=67f88933&"
import script from "./GiftCardManagerCreate.vue?vue&type=script&lang=js&"
export * from "./GiftCardManagerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports